import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import SoftBadge from 'components/common/SoftBadge';

const ProximosEventos = ({ 
    proximoEvento, 
    cargando, 
    setIdLead, 
    setShowModal,
    eventosNoTerminados 
}) => {
    return (
        <Col className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <Row>
                <Col className="col-12">
                    <Row>
                        <Col className="col-12 fs--1">
                            {cargando ? (
                                <Skeleton />
                            ) : (
                                <>
                                    <label className="muted">Eventos próximos: &nbsp;</label>
                                    <Link to={"#"} onClick={() => eventosNoTerminados()}>
                                        Ver eventos
                                    </Link>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {cargando ? (
                            <Row>
                                <Col className="col-6">
                                    <Skeleton height={100} />
                                </Col>
                                <Col className="col-6">
                                    <Skeleton height={100} />
                                </Col>
                            </Row>
                        ) : proximoEvento.length > 0 ? (
                            proximoEvento.map((event, index) => (
                                <EventoCard
                                    key={index}
                                    event={event}
                                    setIdLead={setIdLead}
                                    setShowModal={setShowModal}
                                />
                            ))
                        ) : (
                            <label className="fw-bold text-danger">
                                Ningún próximo evento programado
                            </label>
                        )}
                    </Row>
                </Col>
            </Row>
        </Col>
    );
};

const EventoCard = ({ event, setIdLead, setShowModal }) => {
    const getMes = (fecha) => {
        const meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
        return meses[new Date(fecha).getMonth()];
    };

    return (
        <Col className="h-100 mt-2 fs--2 border-end col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <Row>
                <Col className="col-12">
                    <Link to={"#"} onClick={() => { setIdLead(event.idLead); setShowModal(true); }}>
                        {"Lead " + event.idLead + " - " + event.vNombreLead}
                    </Link>
                </Col>
            </Row>
            <Row className="justify-content-left">
                <Col className="col-3 col-xxl-3 col-xl-4 col-lg-4 col-md-3 col-sm-4 align-item-center align-self-center">
                    <Card className="m-0 p-0 align-self-center">
                        <Card.Header className="m-0 p-0 text-center text-light fw-bold" style={{ backgroundColor: "#e63757", fontSize: "0.8em" }}>
                            {getMes(event.dFechaEvento)}
                        </Card.Header>
                        <Card.Body className="m-0 p-0 text-center border border-danger fw-bold text-muted" style={{ fontSize: "1.2em" }}>
                            {new Date(event.dFechaEvento).getDate()}
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="col-9 col-xxl-9 col-xl-8 col-lg-8 col-md-6 col-sm-5 p-0">
                    <Row>
                        <Col className="col-12 text-xxl-start text-xl-start text-lg-start text-md-start text-sm-center col">
                            <span className="fw-bold fs--2">
                                <Link to="#" onClick={() => { setIdLead(event.idLead); setShowModal(true); }}>
                                    {event.vTituloEvento}
                                </Link>
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col className="col-12 mt-1">
                    <img width={20} src="/img/reloj48.png" alt="reloj" />
                    {new Date(event.dFechaEvento).toLocaleTimeString('es-mx', { hour12: true })}
                    <SoftBadge
                        className="ms-1"
                        bg={
                            event.minLeft > 10 && event.minLeft < 20 ? "warning" :
                            event.minLeft > 0 && event.minLeft <= 10 ? "danger" : "success"
                        }
                    >
                        {"Faltan " + event.minLeft + " mins"}
                    </SoftBadge>
                </Col>
            </Row>
            <br />
        </Col>
    );
};

ProximosEventos.propTypes = {
    proximoEvento: PropTypes.array.isRequired,
    cargando: PropTypes.bool.isRequired,
    setIdLead: PropTypes.func.isRequired,
    setShowModal: PropTypes.func.isRequired,
    eventosNoTerminados: PropTypes.func.isRequired
};

EventoCard.propTypes = {
    event: PropTypes.object.isRequired,
    setIdLead: PropTypes.func.isRequired,
    setShowModal: PropTypes.func.isRequired
};

export default ProximosEventos;
